import React, { useState } from "react";
import { NotificationsContainer } from "./style";
import Notifications from "./containers/notifications";

const Notification = () => {
  const [notificationPanel, showNotificationPanel] = useState(false);
  const [notificationNum, setNotificationNum] = useState(
    localStorage.getItem("unread_notifications_num")
  );
  return (
    <React.Fragment>
      <NotificationsContainer
        onClick={() => showNotificationPanel(!notificationPanel)}
      >
        <i
          title="اعلانات"
          className={
            (notificationPanel ? "pressed " : "") +
            "left-side-icon icon mapsa-notification"
          }
        />
        {parseInt(notificationNum) > 0 && (
          <div className="sidebar-badge">
            <span>{notificationNum}</span>
          </div>
        )}
      </NotificationsContainer>
      {notificationPanel && (
        <Notifications
          changeNumberOfUnreadNofication = {(n) => setNotificationNum(n)}
          show={ notificationPanel}
          handleShow={(show)=>showNotificationPanel(show)}
        />
      )}
    </React.Fragment>
  );
};

export default Notification;